import Vue from 'vue'
const store = {}
export const bus = new Vue({
  data: {
    store: store
  },
  created: function () {}
})
